<template>
    <div class="fill-height">

        <v-progress-linear
                :active="inLoading"
                :indeterminate="inLoading"
                absolute
                color="deep-purple-accent-4"
        ></v-progress-linear>

        <v-snackbar color="error" location="top" v-model="snackbarError" :timeout="15000">
            <span>{{ message }}</span>
            <template v-slot:actions>
                <v-btn variant="text" @click="snackbarError = false">{{ $t('close') }}</v-btn>
            </template>
        </v-snackbar>

        <v-snackbar color="success" location="top" v-model="snackbarSuccess" :timeout="15000">
            <span>{{ message }}</span>
            <template v-slot:actions>
                <v-btn variant="text" @click="snackbarSuccess = false">{{ $t('close') }}</v-btn>
            </template>
        </v-snackbar>

        <v-container class="fill-height" fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" md="4">
                    <v-card class="elevation-12">

                        <v-card-text>
                            <v-form ref="form" v-model="formValid">
                                <v-text-field
                                        ref="email"
                                        :label="$t('email')"
                                        name="email"
                                        type="text"
                                        variant="outlined"
                                        :rules="emailRules"
                                        required
                                        :disabled="isSuccess"
                                        v-model="email"
                                ></v-text-field>
                                <v-text-field
                                        ref="password"
                                        :label="$t('password')"
                                        name="password"
                                        type="password"
                                        variant="outlined"
                                        counter
                                        :rules="passwordRules"
                                        required
                                        :append-icon="'mdi-eye-off'"
                                        :disabled="isSuccess"
                                        v-model="password"
                                ></v-text-field>
                                <v-btn color="success" style="min-height: 50px" block @click="register()"
                                       :disabled="inProgress || inLoading">
                                    {{ $t('register') }}
                                </v-btn>
                            </v-form>
                        </v-card-text>
                    </v-card>

                    <v-col class="text-center">
                        <div class="my-8 text-subtitle-1">
                            <span>{{ $t('haveAccount') }} <router-link
                                    to="/login">{{ $t('login') }}</router-link></span>
                        </div>
                    </v-col>

                </v-col>
            </v-row>

        </v-container>
    </div>
</template>

<script>

    import api from './backend-api'
    import { useI18n } from 'vue-i18n'
    import { useStore } from 'vuex'

    const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/;

    export default {
        name: 'Registration',
        setup() {
            const { t } = useI18n();
            const store = useStore();
            return { t, store };
        },
        data() {
            return {
                email: '',
                password: '',
                message: false,
                snackbarError: false,
                snackbarSuccess: false,
                inProgress: false,
                inLoading: false,
                isSuccess: false,
                formValid: false,
            }
        },
        computed: {
            emailRules() {
                return [
                    v => !!v || this.t('emailRequired'),
                    v => emailRegex.test(v) || this.t('emailNotValid'),
                ];
            },
            passwordRules() {
                return [
                    v => !!v || this.t('passwordRequired'),
                    v => passwordRegex.test(v) || this.t('passwordFormat'),
                ];
            },
        },
        methods: {
            async register() {
                const { valid } = await this.$refs.form.validate();
                if (!valid) return;

                this.inProgress = true;
                this.inLoading = true;

                api.register(this.email, this.password)
                    .then(response => {
                        if (response.data.success) {
                            this.isSuccess = true;
                            this.message = response.data.message;
                            this.inLoading = false;
                            this.snackbarSuccess = true;
                        } else {
                            this.inProgress = false;
                            this.inLoading = false;
                            this.message = response.data.message;
                            this.snackbarError = true;
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        this.message = this.t('connectionLost');
                        this.snackbarError = true;
                        this.inProgress = false;
                        this.inLoading = false;
                    })
            }
        },
        created() {
            const msg = this.store.getters.message;
            if (msg) {
                this.message = msg;
                this.snackbarError = true;
                this.store.commit('clearMessage');
            }
        }
    }
</script>

<style scoped>

</style>
